import React, { Component } from 'react'
import { connect } from 'react-redux';
class StudentDashboardMenu extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        const baseClass = 'dash-menu';
        const inProgressClass = baseClass + ((this.props.activeItem == 1)? ' active': '');
        const completedClass = baseClass + ((this.props.activeItem == 3)? ' active': '');
        const profileClass = baseClass + ((this.props.activeItem == 4)? ' active': '');
        const referralsClass = baseClass + ((this.props.activeItem == 5)? ' active': '');
        return (
            <div className="navigation-wrapper">
                <div className="navigation-title">Navigation</div>
                <br/><br/>
                <div className={inProgressClass} onClick={this.props.changeTab.bind(this, 1)}>Documents in Progress</div>
                <br/>
                <div className={completedClass} onClick={this.props.changeTab.bind(this, 3)}>Completed Documents</div>
                <br/>
                <div className={profileClass} onClick={this.props.changeTab.bind(this, 4)}>My Profile</div>
                <br/>
                <div className={referralsClass} onClick={this.props.changeTab.bind(this, 5)}>Referrals</div>
          </div>
        )
    }
}
export default connect( ({Dashboard, User}) => ({Dashboard, User}) ) (StudentDashboardMenu)


// WEBPACK FOOTER //
// ./src/components/dashboards/StudentDashboardMenu.js